import React, { useState, useMemo } from "react";
import { Modal, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faStar } from "@fortawesome/free-solid-svg-icons";
import { BasicFetch } from "../../utils/BasicFetch.ts";
const FeedbackForm = ({
  feedback,
  setFeedback,
  goBack,
}: {
  feedback: string,
  goBack: () => void,
  setFeedback: (feedback: string) => void,
}) => {

  return (
    <div>
      <Button variant="outline-light" onClick={goBack} className="mb-3">
        <FontAwesomeIcon icon={faArrowLeft} className="mr-2" />
        Back
      </Button>
      <p>
        I'm sorry to hear that you're not satisfied with RepTool. Please let me know how I can improve.
      </p>
      <textarea
        className="form-control"
        placeholder="Enter your feedback here"
        value={feedback}
        onChange={(e) => setFeedback(e.target.value)}
      />
    </div>
  );
}
const RatingForm = ({
  rating,
  setRating,
}: {
  rating: number,
  setRating: (rating: number) => void,
}) => {
  return (
    <>
      <p>
        Thank you for using RepTool! Please consider taking a moment to rate us. Your rating helps grow the RepTool community and improve the app.
      </p>
      <div className="rating-stars gap-2 mt-5 d-flex justify-content-center">
        {[1, 2, 3, 4, 5].map((star) => (
          <FontAwesomeIcon
            key={star}
            icon={faStar}
            size='2x'
            className={rating >= star ? "active mr-2" : "mr-2"}
            style={{
              cursor: "pointer",
              opacity: rating >= star ? 1 : 0.5
            }}
            onClick={() => setRating(star)}
          />
        ))}
      </div>
    </>
  );
}



export const RatingModal = ({
  show,
  onHide,
}: {
  show: boolean,
  onHide: () => void,
}) => {
  const [rating, setRating] = useState<number>(0);
  const [showFeedbackForm, setShowFeedbackForm] = useState<boolean>(false);
  const [feedback, setFeedback] = useState<string>("");
  const isCordova = useMemo(() => {
    return (window as any).cordova;
  }, []);

  const submitFeedback = () => {
    const url = `${(window as any).serverLocation}/rating_request/feedback`;

    BasicFetch({
      url,
      method: 'POST',
      data: {
        feedback,
        rating
      },
      onSuccess: ({ rating }) => {
      },
      onFinish: () => {
        onHide();
      }
    })
  }

  const updateRating = (rating: number) => {
    const url = `${(window as any).serverLocation}/rating_request/reviewed`;
    BasicFetch({
      url,
      method: 'POST',
      data: {
        rating
      },
      onSuccess: () => {
      },
      onFinish: () => {
        onHide();
      }
    })
  }

  const optOut = () => {
    const url = `${(window as any).serverLocation}/rating_request/opt_out`;
    BasicFetch({
      url,
      method: 'POST',
      onSuccess: () => {
      },
      onFinish: () => {
        onHide();
      }
    })
  }

  const submitRating = () => {
    if (!showFeedbackForm) {
      const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
      // determine what app store to send the user to
      // based on the platform the
      // user is currently using
      if (rating >= 4) {
        // send user to app store
        // to leave a review
        // if rating is 4 or 5
        const apple = 'https://apps.apple.com/app/reptool/id1394383716?action=write-review';
        const android = '"https://play.google.com/store/apps/details?id=com.RepTool"';
        const isAppleDevice = /iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream;
        onHide();
        if (isCordova && (window as any).cordova.InAppBrowser) {
          (window as any).cordova.InAppBrowser.open(
            isAppleDevice ? apple : android,
            '_system', 'location=yes');
          updateRating(rating);
        } else {
          updateRating(rating);
        }

      } else {
        // show feedback form
        setShowFeedbackForm(true);
      }
    } else {
      submitFeedback();
    }
  }


  return (
    <Modal show={show} onHide={onHide} className="small-modal">
      <Modal.Header closeButton>
        <Modal.Title>Rate RepTool</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {showFeedbackForm ? (
          <FeedbackForm feedback={feedback} setFeedback={setFeedback} goBack={
            () => setShowFeedbackForm(false)
          } />
        ) : (
          <RatingForm rating={rating} setRating={setRating} />
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={optOut}>
          Opt Out
        </Button>
        <Button variant="primary" onClick={submitRating}>
          {showFeedbackForm ? "Submit Feedback" : "Submit Rating"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}